import AxiosInstance from "./api";

const AccountingStatement5Service = {
  findAccounts: (params) => {
    return AxiosInstance.get("/private/accounting-statement-5/accounts", { params });
  },
  preview: (params) => {
    return AxiosInstance.get("/private/accounting-statement-5/sync/preview", { params });
  },
  sync: (data) => {
    return AxiosInstance.post("/private/accounting-statement-5/sync", data);
  },
  findAll: (params) => {
    return AxiosInstance.get("/private/accounting-statement-5", { params });
  },
  findById: (id) => {
    return AxiosInstance.get(`/private/accounting-statement-5/${id}`);
  },
  update: (id, data) => {
    return AxiosInstance.put(`/private/accounting-statement-5/${id}`, data);
  },
  delete: (id) => {
    return AxiosInstance.delete(`/private/accounting-statement-5/${id}`);
  },
};

export default AccountingStatement5Service;
